import { FunctionComponent, ReactNode } from 'react';

import { Stack, Typography } from '@mui/material';

import { HStack } from './HStack';

interface IEditorListSectionProps {
  title: string;
  /** The rule that governs the list, e.g. "Up to 5 links". */
  caption: string;
  /** The section's single header action — normally the Add button. */
  action: ReactNode;
  /** The rows. Pass nothing (or `false`) when the list is empty; the header stands alone. */
  children?: ReactNode;
}

/**
 * The shell shared by the list editors that sit inside a form modal — `AttachmentUploadList` and
 * `LinkEditorList` are stacked together in the notice editor, so the header rhythm, the caption
 * treatment and the gap to the rows are defined once, here, rather than copied and left to drift.
 */
export const EditorListSection: FunctionComponent<IEditorListSectionProps> = (props: IEditorListSectionProps) => {

  const { title, caption, action, children } = props;

  return (
    <Stack rowGap={3}>
      <HStack justifyContent='space-between'>
        <Stack>
          <Typography fontWeight={500}>{title}</Typography>
          <Typography variant='caption'>{caption}</Typography>
        </Stack>

        {action}
      </HStack>

      {children}
    </Stack>
  );
};
